import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import Transition from './Transition';

const styles = () => ({
	dialogPaper: {
		overflow: 'scroll',
		maxWidth: '100%',
		width: 600,
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	dialogPadding: {
		padding: '20px 30px 30px 30px',
	},
	fileInput: {
		marginTop: 16,
		marginBottom: 16,
	},
	resultSection: {
		marginTop: 16,
		padding: '12px 16px',
		backgroundColor: '#f5f5f5',
		borderRadius: 4,
	},
	errorDetail: {
		marginTop: 8,
		fontSize: 12,
		color: '#c62828',
	},
});

class UploadLfEnergyCsvDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedFile: null,
			isSubmitting: false,
			results: null,
			error: null,
		};
	}

	handleFileChange = (event) => {
		const file = event.target.files[0] || null;
		this.setState({ selectedFile: file, results: null, error: null });
	};

	handleSubmit = () => {
		const { selectedFile } = this.state;
		if (!selectedFile) {
			return;
		}

		this.setState({ isSubmitting: true, results: null, error: null });

		this.props.uploadLfEnergyCsv({
			file: selectedFile,
			callback: (err, result) => {
				if (err) {
					const errMsg = _.isArray(err) ? err.join(', ') : String(err);
					this.setState({ isSubmitting: false, error: errMsg });
					return;
				}
				this.setState({ isSubmitting: false, results: result.uploadResults });
				this.props.onAfterUpload();
			},
		});
	};

	handleClose = () => {
		this.setState({ selectedFile: null, results: null, error: null, isSubmitting: false });
		this.props.onClose();
	};

	render() {
		const { classes, open, fullScreen } = this.props;
		const { selectedFile, isSubmitting, results, error } = this.state;

		return (
			<Dialog
				fullScreen={fullScreen}
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper }}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle style={{ padding: 0, paddingBottom: 8 }}>
						Upload LF Energy Billing CSV
					</DialogTitle>
					<DialogContent style={{ padding: 0 }}>
						<div className={classes.fileInput}>
							<input
								type="file"
								accept=".csv,text/csv"
								onChange={this.handleFileChange}
							/>
						</div>

						{results && (
							<div className={classes.resultSection}>
								<Typography variant="subtitle1" style={{ fontWeight: 600 }}>
									Results
								</Typography>
								<Typography variant="body2">
									Bills queued successfully: {results.successful}
								</Typography>
								<Typography variant="body2">
									Bills queued with errors: {results.withErrors}
								</Typography>
								<Typography variant="body2">
									Bills skipped (already in queue): {results.skipped}
								</Typography>
								{results.withErrors > 0 && (
									<div className={classes.errorDetail}>
										{results.errorDetails.map((detail, i) => (
											<div key={i}>
												Bill #{detail.billNumber}: {detail.errors.join('; ')}
											</div>
										))}
									</div>
								)}
							</div>
						)}

						{error && (
							<Typography
								variant="body2"
								style={{ color: '#c62828', marginTop: 8 }}
							>
								Error: {error}
							</Typography>
						)}
					</DialogContent>

					<DialogActions style={{ padding: 0, paddingTop: 16 }}>
						<Button variant="contained" onClick={this.handleClose}>
							Close
						</Button>
						<Button
							variant="contained"
							color="primary"
							onClick={this.handleSubmit}
							disabled={!selectedFile || isSubmitting}
						>
							{isSubmitting ? (
								<>
									<CircularProgress size={20} style={{ marginRight: 8, color: '#fff' }} />
									Processing...
								</>
							) : (
								'Submit'
							)}
						</Button>
					</DialogActions>
				</div>
			</Dialog>
		);
	}
}

UploadLfEnergyCsvDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onAfterUpload: PropTypes.func.isRequired,
	uploadLfEnergyCsv: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
	fullScreen: PropTypes.bool.isRequired,
};

export default _.flow([withStyles(styles), withMobileDialog()])(UploadLfEnergyCsvDialog);
